import { styled } from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { SuggestedFaqStatus } from '@/models/suggestedFaq.model';

export const statusColors: Record<SuggestedFaqStatus, { color: string; background: string }> = {
  [SuggestedFaqStatus.PENDING]: { color: COLORS.STATUS_WARNING, background: 'rgba(247, 166, 46, 0.12)' },
  [SuggestedFaqStatus.EDITED]: { color: COLORS.BLUE_MAIN, background: 'rgba(0, 115, 187, 0.12)' },
  [SuggestedFaqStatus.APPROVED]: { color: COLORS.STATUS_SUCCESS, background: 'rgba(14, 154, 78, 0.12)' },
  [SuggestedFaqStatus.REJECTED]: { color: COLORS.STATUS_ERROR, background: 'rgba(236, 33, 40, 0.12)' },
};

export const StyledStatusPill = styled.span<{ $status: SuggestedFaqStatus }>`
  display: inline-flex;
  border-radius: 999px;
  align-items: center;
  padding: 0.25rem 0.6875rem;
  ${pickThemeFontStyles('12', '16', 'BOLD')}
  color: ${({ $status }) => statusColors[$status].color};
  background-color: ${({ $status }) => statusColors[$status].background};
  text-transform: capitalize;
`;
